import React from 'react';
import PropTypes from 'prop-types';

export const BaseIcon = ({
    icon = 'question',
    iconType = 'far',
    iconClassName,
    className = '',
    size = '1x',
    color = 'primary'
}) => {
    return (
        <span key={Math.random()} className={`icon ${className}`}>
            <i className={`${iconType} fa-${icon} fa-${size} text-${color} ${iconClassName}`}></i>
        </span>
    );
};

BaseIcon.propTypes = {
    iconClassName: PropTypes.string,
    className: PropTypes.string,
    iconType: PropTypes.string,
    icon: PropTypes.string,
    size: PropTypes.string,
    color: PropTypes.string
};
